// @flow

const CAR: 'car' = 'car';
const PLANE: 'plane' = 'plane';
const UNKNOWN: 'unknown' = 'unknown';

export const TYPE = Object.freeze({
    car: CAR,
    plane: PLANE,
    unknown: UNKNOWN
});

export const DATA_SOURCE_BUFFER_SIZE = 30;